import { render, staticRenderFns } from "./ModalAcaoContatos.vue?vue&type=template&id=3b511bdd&scoped=true"
import script from "./ModalAcaoContatos.vue?vue&type=script&lang=js"
export * from "./ModalAcaoContatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b511bdd",
  null
  
)

export default component.exports